export default "__VITE_ASSET__frs$hDzi__"